import {BasicScenario} from '../../../../allkey/framework/parameters/BasicScenario';

export class FlowScenario extends BasicScenario {
manageSteps: boolean | null;
}

